// extracted by mini-css-extract-plugin
export default {"moveArrow":"MoveArrow_moveArrow__nKiZx","iconArea":"MoveArrow_iconArea__Ov7U+"};